type MultipartList = readonly (string | number)[]
type MultipartRecordList = readonly Readonly<Record<string, string | number>>[]
type MultipartScalar = string | number | boolean | null
type MultipartFieldValue = MultipartScalar | Blob | MultipartList | MultipartRecordList | undefined

const isRecordList = (
  value: Exclude<MultipartFieldValue, undefined>
): value is MultipartRecordList =>
  Array.isArray(value) &&
  value.length > 0 &&
  value.every((item) => typeof item === 'object' && item !== null)

const isList = (value: Exclude<MultipartFieldValue, undefined>): value is MultipartList =>
  Array.isArray(value)

const scalarText = (value: MultipartScalar): string => {
  if (value === null) return ''
  if (typeof value === 'boolean') return value ? '1' : '0'
  return String(value)
}

const appendList = (body: FormData, key: string, items: MultipartList): void => {
  const name = `${key}[]`
  if (items.length === 0) {
    body.append(name, '')
    return
  }
  for (const item of items) body.append(name, String(item))
}

const appendRecordList = (body: FormData, key: string, items: MultipartRecordList): void => {
  items.forEach((item, index) => {
    for (const [field, value] of Object.entries(item)) {
      body.append(`${key}[${index}][${field}]`, String(value))
    }
  })
}

const appendField = (
  body: FormData,
  key: string,
  value: Exclude<MultipartFieldValue, undefined>
): void => {
  if (isRecordList(value)) appendRecordList(body, key, value)
  else if (isList(value)) appendList(body, key, value)
  else if (value instanceof Blob) body.append(key, value)
  else body.append(key, scalarText(value))
}

export const buildMultipartBody = (
  fields: Readonly<Record<string, MultipartFieldValue>>
): FormData => {
  const body = new FormData()
  for (const [key, value] of Object.entries(fields)) {
    if (value !== undefined) appendField(body, key, value)
  }
  return body
}
